'use client';

import { Copy } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';

const shortenAddress = (address: string) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

interface I_TokenImportCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  tokenAddress?: string;
  tokenSymbol?: string;
}

export function TokenImportCheckbox({
  checked,
  onCheckedChange,
  disabled = false,
  id = 'import-token',
  tokenAddress,
  tokenSymbol
}: I_TokenImportCheckboxProps) {
  const t = useTranslations('pools');

  const handleCopy = () => {
    if (!tokenAddress) return;
    navigator.clipboard.writeText(tokenAddress);
    toast.success(t('addressCopied'));
  };

  return (
    <>
      {/* Desktop: Show Checkbox */}
      <div className="hidden md:flex items-center gap-2">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={value => onCheckedChange(value === true)}
          disabled={disabled}
        />
        <label
          htmlFor={id}
          className="text-sm font-normal leading-tight cursor-pointer text-foreground"
        >
          {t('importTokenInWallet')}
        </label>
      </div>

      {/* Mobile: Show Copy Address Button */}
      <div className="flex md:hidden w-full">
        <Button
          variant="secondary"
          size="sm"
          className="w-full flex items-center justify-center gap-2 text-xs font-mono"
          onClick={handleCopy}
          disabled={!tokenAddress}
        >
          <span>
            Import Token {tokenAddress ? shortenAddress(tokenAddress) : '...'}
          </span>
          <Copy className="h-3 w-3" />
        </Button>
      </div>
    </>
  );
}
